module.exports = __webpack_public_path__ + "static/media/open-sans-regular.aeb4b1bf.woff2";